import { createPaginatedList } from "MODULES/shared/pagination";
import { merge } from "lodash";
import api from "APP_ROOT/api";

export default createPaginatedList({
  listId: "inventorySearch",
  fetch: params =>
    api.inventories.search(merge({ presenter_type: "search" }, params || {})),
  forceDebounce: true,
  stateLocator: state => state.inventoryPagination,
  initialSettings: {
    sortReverse: true,
    sort: "date_received",
    presenter_type: "search"
  }
});



// WEBPACK FOOTER //
// ./app/modules/inventories/pagination.js